import * as Artist from "./types/Artist.js";
import * as Component from "./types/Component.js";
import * as Comment from "./types/Comment.js";
import * as Contribution from "./types/Contribution.js";
import * as Equipment from "./types/Equipment.js";
import * as File from "./types/File.js";
import * as Genre from "./types/Genre.js";
import * as Tag from "./types/Tag.js";
import * as Image from "./types/Image.js";
import * as Instrument from "./types/Instrument.js";
import * as Label from "./types/Label.js";
import * as Mood from "./types/Mood.js";
import * as Organisation from "./types/Organisation.js";
import * as Party from "./types/Party.js";
import * as Person from "./types/Person.js";
import * as Payment from "./types/Payment.js";
import * as Project from "./types/Project.js";
import * as Recording from "./types/Recording.js";
import * as Release from "./types/Release.js";
import * as ReleaseDeal from "./types/ReleaseDeal.js";
import * as ReleaseDetail from "./types/ReleaseDetail.js";
import * as Share from "./types/Share.js";
import * as Text from "./types/Text.js";
import * as Video from "./types/Video.js";
import * as Work from "./types/Work.js";
import * as PublicProfile from "./types/PublicProfile";
import * as SourceFile from "./types/SourceFile";
import * as Invitation from "./types/Invitation";
import * as Statistics from "./types/Statistics";
import * as SharedComponent from "./types/SharedComponent";
import * as Reference from "./types/Reference";

export const addRelationshipQueryMap = {
  AddProjectOwners: Project.ADD_PROJECT_OWNERS,
  AddProjectMembers: Project.ADD_PROJECT_MEMBERS,
  AddProjectMembersWithSharedComponent:
    Project.ADD_PROJECT_MEMBERS_WITH_SHARED_COMPONENT,
  AddProjectContributions: Project.ADD_PROJECT_CONTRIBUTIONS,
  AddContributionTags: Contribution.ADD_CONTRIBUTION_TAGS,
  ResetTagsToContribution: Contribution.RESET_CONTRIBUTION_TAGS,
  AddContributionContributor: Contribution.ADD_CONTRIBUTION_CONTRIBUTOR,
  AddRecordingStems: Recording.ADD_RECORDING_STEMS,
  AddRecordingSampledRecordings: Recording.ADD_RECORDING_SAMPLED_RECORDINGS,
  ResetContributionContributors: Contribution.RESET_CONTRIBUTION_CONTRIBUTORS,
  AddCommentCommentable: Comment.ADD_COMMENT_COMMENTABLE,
  AddCommentAuthor: Comment.ADD_COMMENT_AUTHOR,
  AddRecordingReferrer: Recording.ADD_RECORDING_REFERRER,
  AddVideoReferrer: Video.ADD_VIDEO_REFERRER,
  AddImageReferrer: Image.ADD_IMAGE_REFERRER,
  AddImgDepiction: Person.ADD_IMG_DEPICTION,
  AddSourceFileComponentCreator: SourceFile.ADD_SOURCE_FILE_COMPONENT_CREATOR,
};

export const removeRelationshipQueryMap = {
  RemoveProjectOwners: Project.REMOVE_PROJECT_OWNERS,
  RemoveProjectMember: Project.REMOVE_PROJECT_MEMBER,
  SoftRemoveSelfFromProject: Project.SOFT_REMOVE_SELF_FROM_PROJECT,
  HardRemoveSelfFromProject: Project.HARD_REMOVE_SELF_FROM_PROJECT,
  RemoveProjectContributions: Project.REMOVE_PROJECT_CONTRIBUTIONS,
  RemoveContributionTags: Contribution.REMOVE_CONTRIBUTION_TAGS,
  RemoveContributionContributor: Contribution.REMOVE_CONTRIBUTION_CONTRIBUTOR,
  RemoveRecordingStems: Recording.REMOVE_RECORDING_STEMS,
  RemoveRecordingSampledRecordings:
    Recording.REMOVE_RECORDING_SAMPLED_RECORDINGS,
  RemoveCommentCommentable: Comment.REMOVE_COMMENT_COMMENTABLE,
  RemoveImgDepictions: Person.REMOVE_IMG_DEPICTIONS,
};

export const searchQueryMap = {
  Artist: Party.SEARCH_PARTIES,
  Comment: Comment.SEARCH_COMMENTS,
  Contribution: Contribution.SEARCH_CONTRIBUTIONS,
  Equipment: Equipment.SEARCH_EQUIPMENTS,
  File: File.SEARCH_FILES,
  Image: Component.SEARCH_COMPONENTS,
  Genre: Genre.SEARCH_GENRES,
  Instrument: Instrument.SEARCH_INSTRUMENTS,
  Label: Party.SEARCH_PARTIES,
  Mood: Mood.SEARCH_MOODS,
  Organisation: Party.SEARCH_PARTIES,
  Payment: Payment.SEARCH_PAYMENTS,
  Person: Party.SEARCH_PARTIES,
  Project: Project.SEARCH_PROJECTS,
  Recording: Component.SEARCH_COMPONENTS,
  Release: Release.SEARCH_RELEASES,
  ReleaseDeal: ReleaseDeal.SEARCH_RELEASEDEALS,
  ReleaseDetail: ReleaseDetail.SEARCH_RELEASEDETAILS,
  Share: Share.SEARCH_SHARES,
  Text: Component.SEARCH_COMPONENTS,
  Video: Component.SEARCH_COMPONENTS,
  Work: Work.SEARCH_WORKS,
  StemmerSearchPeople: Person.STEMMER_SEARCH_PEOPLE,
  StemmerSearchTag: Tag.STEMMER_SEARCH_TAG,
  PersonId: Person.GET_PERSON_FROM_ACCOUNT_ID,
  PeopleNotInProject: Person.STEMMER_SEARCH_PEOPLE_NOT_IN_PROJECT,
  ProjectsOwnersOrMembers: Project.SEARCH_FOR_PROJECT_OWNERS_OR_MEMBERS,
  PersonByEmail: Person.SEARCH_PEOPLE_BY_EMAIL,
};

export const getQueryMap = {
  Artist: Artist.GET_ARTIST,
  Genre: Genre.GET_GENRE,
  Equipment: Equipment.GET_EQUIPMENT,
  File: File.GET_FILE,
  Image: Image.GET_IMAGE,
  Instrument: Instrument.GET_INSTRUMENT,
  Invitation: Invitation.GET_INVITATION,
  Label: Label.GET_LABEL,
  Mood: Mood.GET_MOOD,
  Organisation: Organisation.GET_ORGANISATION,
  Person: Person.GET_PERSON,
  PersonByAccountId: Person.GET_PERSON_BY_ACCOUNT_ID,
  PersonByEmail: Person.GET_PERSON_BY_EMAIL,
  PersonGetImgDepictionsOfType: Person.GET_IMG_DEPICTIONS_OF_TYPE,
  Project: Project.GET_PROJECT,
  AllProjectsByOwnerId: Project.GET_ALL_PROJECTS_OWNED_BY_PERSON,
  AllProjectsByOwnerOrMemberId: Project.GET_ALL_PROJECTS_BY_OWNER_OR_MEMBER_ID,
  AllTasksOfProject: Contribution.GET_TASKS_OF_PROJECT,
  AllTasksOfMultipleProjects: Contribution.GET_TASKS_OF_MULTIPLE_PROJECT,
  AllComponentsOfProject: Component.GET_COMPONENTS_OF_PROJECT,
  ArchivedComponentsOfProject: Component.GET_ARCHIVED_COMPONENTS_OF_PROJECT,
  AllReferencesInProject: Project.GET_PROJECTS_REFERENCES,
  AllLiveStreamsInProject: Project.GET_PROJECTS_LIVESTREAMS,
  ProjectOwnersAndMembers: Project.GET_PROJECT_OWNERS_AND_MEMBERS,
  Recording: Recording.GET_RECORDING,
  SourceFile: SourceFile.GET_SOURCEFILE,
  Release: Release.GET_RELEASE,
  Video: Video.GET_VIDEO,
  Work: Work.GET_WORK,
  Tag: Tag.GET_TAG,
  Text: Text.GET_TEXT,
  PublicProfile: PublicProfile.GET_PUBLIC_PROFILE,
  AllUserFiles: Component.GET_ALL_USERS_COMPONENTS,
  AllUserFilesLimitedProps: Component.GET_ALL_USERS_COMPONENTS_LIMITED_PROPS,
  AllProjectsComponents: Component.GET_ALL_PROJECTS_COMPONENTS,
  AllDashboardComponents: Component.GET_ALL_DASHBOARD_COMPONENTS,
  HasProjectMemberContributed: Project.HAS_PROJECT_MEMBER_CONTRIBUTED,
  BasicStatistics: Statistics.BASIC_STATISTICS,
  SharedComponent: SharedComponent.GET_SHARED_COMPONENT,
  RecordingReference: Reference.GET_RECORDING_REFERENCE,
  ImageReference: Reference.GET_IMAGE_REFERENCE,
  TextReference: Reference.GET_TEXT_REFERENCE,
  VideoReference: Reference.GET_VIDEO_REFERENCE,
  SourceFileReference: Reference.GET_SOURCE_FILE_REFERENCE,
  ComponentComments: Component.GET_COMPONENT_COMMENTS,
  ComponentContributors: Component.GET_COMPONENT_CONTRIBUTORS,
  ComponentSharedComponents: Component.GET_COMPONENT_SHARED_COMPONENTS,
  AttributionsOfPersonInComponent: Person.GET_ROLES_FOR_COMPONENT,
  FounderMemberStatus: Person.GET_FOUNDER_MEMBER_STATUS,
};

export const createQueryMap = {
  Artist: Artist.CREATE_ARTIST,
  Comment: Comment.CREATE_COMMENT_ON_COMMENTABLE_WITH_AUTHOR,
  Contribution: Contribution.CREATE_CONTRIBUTION_WITH_PROJECT_CONTRIBUTION,
  Equipment: Equipment.CREATE_EQUIPMENT,
  File: File.CREATE_FILE,
  Genre: Genre.CREATE_GENRE,
  Image: Image.CREATE_IMAGE_WITH_REFERRER,
  Instrument: Instrument.CREATE_INSTRUMENT,
  InvitedPerson: Invitation.CREATE_PERSON_WITH_INVITATION,
  InvitationWithSharedComponent:
    Invitation.CREATE_INVITATION_WITH_SHARED_COMPONENT,
  Label: Label.CREATE_LABEL,
  Mood: Mood.CREATE_MOOD,
  Organisation: Organisation.CREATE_ORGANISATION,
  Payment: Payment.CREATE_PAYMENT,
  Person: Person.CREATE_PERSON,
  Project: Project.CREATE_PROJECT_WITH_OWNERS,
  Recording: Recording.CREATE_RECORDING_WITH_REFERRER,
  Release: Release.CREATE_RELEASE,
  ReleaseDeal: ReleaseDeal.CREATE_RELEASEDEAL,
  ReleaseDetail: ReleaseDetail.CREATE_RELEASEDETAIL,
  Share: Share.CREATE_SHARE,
  Text: Text.CREATE_TEXT_WITH_REFERRER,
  Video: Video.CREATE_VIDEO_WITH_REFERRER,
  Work: Work.CREATE_WORK,
  Tag: Tag.CREATE_TAG,
  PublicProfile: PublicProfile.CREATE_PUBLIC_PROFILE,
  PublicLivestream: Video.CREATE_VIDEO_PUBLIC_LIVESTREAM,
  Livestream: Video.CREATE_VIDEO_LIVESTREAM,
  RecordingComponent: Recording.CREATE_RECORDING_COMPONENT,
  RecordingReference: Recording.CREATE_RECORDING_REFERENCE,
  VersionOfRecordingComponent: Recording.CREATE_VERSION_OF_RECORDING_COMPONENT,
  VersionOfRecordingReference: Recording.CREATE_VERSION_OF_RECORDING_REFERENCE,
  SourceFileComponent: SourceFile.CREATE_SOURCE_FILE_COMPONENT,
  SourceFileReference: SourceFile.CREATE_SOURCE_FILE_REFERENCE,
  VersionOfSourceFileComponent:
    SourceFile.CREATE_VERSION_OF_SOURCE_FILE_COMPONENT,
  VersionOfSourceFileReference:
    SourceFile.CREATE_VERSION_OF_SOURCE_FILE_REFERENCE,
  SourceFileComponentContribution:
    Contribution.ADD_SOURCE_FILE_COMPONENT_CONTRIBUTION,
  SharedComponent: SharedComponent.CREATE_SHARED_COMPONENT,
  SharedComponentWithUri: SharedComponent.CREATE_OR_PUBLISH_SHARED_COMPONENT,
  Component: Component.CREATE_COMPONENT,
  VersionOfComponent: Component.CREATE_VERSION_OF_COMPONENT,
  ComponentContribution: Contribution.ADD_COMPONENT_CONTRIBUTION,
  WorkContribution: Contribution.ADD_WORK_CONTRIBUTION,
  ComponentWithWork: Component.CREATE_COMPONENT_WITH_WORK,
  VersionOfComponentWithWork: Component.CREATE_VERSION_OF_COMPONENT_WITH_WORK,
  Reference: Reference.CREATE_REFERENCE,
  VersionOfReference: Reference.CREATE_VERSION_OF_REFERENCE,
  ReferenceWithWork: Reference.CREATE_REFERENCE_WITH_WORK,
  VersionOfReferenceWithWork: Reference.CREATE_VERSION_OF_REFERENCE_WITH_WORK,
};

export const updateQueryMap = {
  Artist: Artist.UPDATE_ARTIST,
  Comment: Comment.UPDATE_COMMENT,
  Contribution: Contribution.UPDATE_CONTRIBUTION,
  Equipment: Equipment.UPDATE_EQUIPMENT,
  File: File.UPDATE_FILE,
  Genre: Genre.UPDATE_GENRE,
  Image: Image.UPDATE_IMAGE,
  Instrument: Instrument.UPDATE_INSTRUMENT,
  Label: Label.UPDATE_LABEL,
  Mood: Mood.UPDATE_MOOD,
  Organisation: Organisation.UPDATE_ORGANISATION,
  Payment: Payment.UPDATE_PAYMENT,
  Person: Person.UPDATE_PERSON,
  InvitedPerson: Person.UPDATE_INVITED_PERSON,
  Project: Project.UPDATE_PROJECT,
  Recording: Recording.UPDATE_RECORDING,
  Release: Release.UPDATE_RELEASE,
  ReleaseDeal: ReleaseDeal.UPDATE_RELEASEDEAL,
  ReleaseDetail: ReleaseDetail.UPDATE_RELEASEDETAIL,
  Share: Share.UPDATE_SHARE,
  Text: Text.UPDATE_TEXT,
  Video: Video.UPDATE_VIDEO,
  Work: Work.UPDATE_WORK,
  Tag: Tag.UPDATE_TAG,
  TaskGroup: Contribution.UPDATE_TASK_GROUP,
  PublicProfile: PublicProfile.UPDATE_PUBLIC_PROFILE,
  PublishVideo: Video.PUBLISH_VIDEO,
  UnpublishVideo: Video.UNPUBLISH_VIDEO,
  RecordingComponent: Recording.UPDATE_RECORDING_COMPONENT,
  SourceFileComponent: SourceFile.UPDATE_SOURCE_FILE_COMPONENT,
  Component: Component.UPDATE_COMPONENT,
  ComponentGroupName: Component.UPDATE_COMPONENT_GROUP_NAME,
  ComponentGroupOrderWeight: Component.UPDATE_COMPONENTS_GROUP_ORDER_WEIGHT,
  ComponentGroupNameAndOrder: Component.UPDATE_COMPONENT_GROUP_NAME_AND_ORDER,
  ComponentContributionRole: Contribution.UPDATE_COMPONENT_CONTRIBUTION_ROLE,
  WorkContributionRole: Contribution.UPDATE_WORK_CONTRIBUTION,
  RecordingComponentContributionRole:
    Contribution.UPDATE_RECORDING_COMPONENT_CONTRIBUTION_ROLE,
  RecordingWorkContributionRole:
    Contribution.UPDATE_CONTRUIBUTION_ON_WORK_RECORDING,
  SourceFileComponentContributionRole:
    Contribution.UPDATE_SOURCE_FILE_COMPONENT_CONTRIBUTION_ROLE,
  UnarchiveComponent: Component.UNARCHIVE_COMPONENT,
  ComponentFile: File.UPDATE_COMPONENT_FILE,
  SnoozeInvitation: Invitation.SNOOZE_INVITATION_48H,
  ReplaceInviteeWithExistingPerson: Person.REPLACE_INVITEE_WITH_EXISTING_PERSON,
  MigratePersonAccountId: Person.MIGRATE_PERSON_ACCOUNT_ID,
  AcceptTermsAndConditions: Person.ACCEPT_TERMS_AND_CONDITIONS,
  SharedComponent: SharedComponent.UPDATE_SHARED_COMPONENT,
  IncrementSharedComponentPlayCount:
    SharedComponent.INCREMENT_SHARED_COMPONENT_PLAY_COUNT,
  IncrementSharedComponentDownloadCount:
    SharedComponent.INCREMENT_SHARED_COMPONENT_DOWNLOAD_COUNT,
};

export const deleteQueryMap = {
  Artist: Artist.DELETE_ARTIST,
  Comment: Comment.DELETE_COMMENT,
  Contribution: Contribution.DELETE_CONTRIBUTION,
  Equipment: Equipment.DELETE_EQUIPMENT,
  File: File.DELETE_FILE,
  Genre: Genre.DELETE_GENRE,
  Image: Image.DELETE_IMAGE,
  Instrument: Instrument.DELETE_INSTRUMENT,
  Label: Label.DELETE_LABEL,
  Mood: Mood.DELETE_MOOD,
  Organisation: Organisation.DELETE_ORGANISATION,
  Payment: Payment.DELETE_PAYMENT,
  Person: Person.DELETE_PERSON,
  Project: Project.DELETE_PROJECT,
  Recording: Recording.DELETE_RECORDING,
  SourceFile: SourceFile.DELETE_SOURCEFILE,
  Release: Release.DELETE_RELEASE,
  ReleaseDeal: ReleaseDeal.DELETE_RELEASEDEAL,
  ReleaseDetail: ReleaseDetail.DELETE_RELEASEDETAIL,
  Share: Share.DELETE_SHARE,
  Text: Text.DELETE_TEXT,
  Video: Video.DELETE_VIDEO,
  Work: Work.DELETE_WORK,
  Tag: Tag.DELETE_TAG,
  Livestream: Video.DELETE_VIDEO_LIVESTREAM,
  Component: Component.TOGGLE_ARCHIVE_COMPONENT,
  ComponentContribution: Contribution.DELETE_COMPONENT_CONTRIBUTION,
  WorkContribution: Contribution.DELETE_WORK_CONTRIBUTION,
  RecordingComponentContribution:
    Contribution.DELETE_RECORDING_COMPONENT_CONTRIBUTION,
  SourceFileComponentContribution:
    Contribution.DELETE_SOURCE_FILE_COMPONENT_CONTRIBUTION,
  WorkRecordingContribution: Contribution.DELETE_WORK_CONTRIBUTION,
};
